/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Input, Button, Loader, Checkbox } from '@scuf/common';
import Routes from '../../common/routes';
import { VadContext } from './VadContext';

class EditRule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        matchingString: null,
        displayMessage: null,
        id: null,
        description: null,
        regularExpression: null,
      },
      loadingSettings: false,
    };
  }

  componentDidMount() {
    const { selectedRows } = this.context;
    const [selectedEntry] = selectedRows;
    this.setState({ form: selectedEntry });
  }

  onMatchingStringChange = (matchingString) => {
    const { form } = this.state;
    this.setState({ form: { ...form, matchingString } });
  };

  onDisplayMessageChange = (displayMessage) => {
    const { form } = this.state;
    this.setState({ form: { ...form, displayMessage } });
  };

  onDescriptionChange = (description) => {
    const { form } = this.state;
    this.setState({ form: { ...form, description } });
  };

  isRegularExpression = (regularExpression) => {
    const { form } = this.state;
    this.setState({ form: { ...form, regularExpression } });
  };

  toggleLoading() {
    this.setState((prevState) => ({
      loadingSettings: !prevState.loadingSettings,
    }));
  }

  render() {
    const { history } = this.props;
    const { loadingSettings, form } = this.state;
    const { editRule } = this.context;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <h1>Edit Rule</h1>
            <Loader loading={loadingSettings} overlayOpacity={0.2} overlayColor="#B2AFAF">
              <div className="placeholder" />
            </Loader>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <Checkbox
              label="Regex"
              checked={form.regularExpression}
              onChange={(data) => this.isRegularExpression(data)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <Input
              fluid
              error={null}
              label="Search String"
              maxLength="200"
              indicator="required"
              value={form.matchingString}
              onChange={(data) => this.onMatchingStringChange(data)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <Input
              fluid
              error={null}
              label="Resolution"
              maxLength="800"
              indicator="required"
              value={form.displayMessage}
              onChange={(data) => this.onDisplayMessageChange(data)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <Input
              fluid
              error={null}
              label="Description"
              maxLength="800"
              placeholder="Description"
              indicator="required"
              value={form.description}
              onChange={(data) => this.onDescriptionChange(data)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <Button
              type="primary"
              content="Submit"
              onClick={async () => {
                this.toggleLoading();
                const response = await editRule(form);
                if (!(response instanceof Error)) {
                  history.push({ pathname: Routes.Rules });
                }
                this.toggleLoading();
              }}
            />
            <Button
              type="primary"
              content="Cancel"
              onClick={async () => {
                history.push({ pathname: Routes.Rules });
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

EditRule.contextType = VadContext;

EditRule.propTypes = {};

export default withRouter(EditRule);
